
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JarabotInstallmentsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myInstallmentsContracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accelerationDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowedPaymentMethods"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"balance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"installments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sanctionClaim"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sanctionInterestClaim"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"sanctionInterestLegalClaim"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"installmentsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"interestRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"loanType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maximumPayment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmountFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nextInstallment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NextInstallmentFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"repaymentDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rpsn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"variableSymbol"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pagingInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PagingInfoFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":833}};
    doc.loc.source = {"body":"#import \"fragments/AmountFragment.graphql\"\n#import \"fragments/NextInstallmentFragment.graphql\"\n#import \"fragments/PagingInfoFragment.graphql\"\n\nquery JarabotInstallmentsQuery($filter: String, $limit: Int) {\n\tmyInstallmentsContracts(filter: $filter, limit: $limit) {\n\t\tdata {\n\t\t\taccelerationDate\n\t\t\tallowedPaymentMethods\n\t\t\tbalance {\n\t\t\t\t...AmountFragment\n\t\t\t}\n\t\t\tid\n\t\t\tinstallments {\n\t\t\t\tsanctionClaim {\n\t\t\t\t\t...AmountFragment\n\t\t\t\t}\n\t\t\t\tsanctionInterestClaim {\n\t\t\t\t\t...AmountFragment\n\t\t\t\t}\n\t\t\t\tsanctionInterestLegalClaim {\n\t\t\t\t\t...AmountFragment\n\t\t\t\t}\n\t\t\t\tstate\n\t\t\t}\n\t\t\tinstallmentsCount\n\t\t\tinterestRate\n\t\t\tloanType\n\t\t\tmaximumPayment {\n\t\t\t\t...AmountFragment\n\t\t\t}\n\t\t\tnextInstallment {\n\t\t\t\t...NextInstallmentFragment\n\t\t\t}\n\t\t\trepaymentDate\n\t\t\trpsn\n\t\t\tstate\n\t\t\ttitle\n\t\t\tvariableSymbol\n\t\t}\n\t\tpagingInfo {\n\t\t\t...PagingInfoFragment\n\t\t}\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("fragments/AmountFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("fragments/NextInstallmentFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("fragments/PagingInfoFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["JarabotInstallmentsQuery"] = oneQuery(doc, "JarabotInstallmentsQuery");
        
